<div class="references" *isLoading="!(result$ | async)">
  <ng-template #noResults>
    {{ 'dialog.references.noResults' | translate }}
  </ng-template>
  <ng-container *ngIf="(result$ | async) as result">
    <table class="table table-stripped" *ngIf="result.total > 0; else noResults">
      <thead>
        <tr>
          <th scope="col">{{ 'components.references.headers.id' | translate }}</th>
          <th scope="col">{{ 'components.references.headers.type' | translate }}</th>
          <th scope="col">{{ 'components.references.headers.name' | translate }}</th>
          <th scope="col">{{ 'components.references.headers.actions' | translate }}</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let reference of result.references">
          <td style="width: 1px">{{ reference.objektId ?? reference.erfassungId }}</td>
          <td style="width: 1px">{{ getType(reference) }}</td>
          <td 
            [title]="reference.name"
            style="max-width: 0; overflow: hidden; white-space: nowrap; text-overflow: ellipsis;">
            {{ reference.name }}
          </td>
          <td style="width: 1px">
            <app-reference-link [reference]="reference"></app-reference-link>
          </td>
        </tr>
      </tbody>
    </table>
    <div *ngIf="result.total > result.references.length" style="text-align: center">
      <button (click)="loadMore()" [disabled]="isBusy$ | async" class="btn btn-default">
        {{ 'components.references.loadMore' | translate }}
      </button>
    </div>
  </ng-container>
</div>
